export class EngagementArchivalInfoViewModel {
    rfcName: string;
    rfcEmailId: string;
    closeoutDueDate: Date;
}